/**
 * Trusted-Shops-Zahlen live einsetzen: Anzahl der Bewertungen und Note auf
 * der PDP sollen nicht mehr von Hand nachgezogen werden.
 *
 * Quelle ist derselbe oeffentliche eTrusted-Feed, aus dem auch das
 * Trusted-Shops-Widget im Shop liest. Damit zeigen PDP und Widget immer
 * dieselben Zahlen: Note der letzten 12 Monate, Anzahl ueber alle Jahre.
 *
 * Markiert werden Elemente per data-lp-ts:
 *   "count"  -> Zahl im Text wird durch die Gesamtanzahl ersetzt (17.526)
 *   "rating" -> Zahl im Text wird durch die Note ersetzt (4,56)
 * Getauscht wird nur die Zahl. Optik, "+" und "Bewertungen" bleiben wie im
 * Theme-Editor. Antwortet der Feed nicht, bleibt der Editor-Text stehen.
 */
(function () {
  'use strict';

  if (window.lpTsStats) return;
  window.lpTsStats = true;

  var FEED = 'https://integrations.etrusted.com/feeds/grades/v1/channels/chl-fd793a2a-9961-465e-9b61-74d7fc5fe6c7/touchpoints/all/feed.json';
  var SPEICHER = 'lp-ts-stats';
  // Der Feed wird einmal am Tag neu berechnet, 6 Stunden reichen locker.
  var MAX_ALTER = 6 * 60 * 60 * 1000;
  var ZAHL = /\d+(?:[.,]\d+)*/;

  function lesen() {
    try {
      return JSON.parse(localStorage.getItem(SPEICHER));
    } catch (e) {
      return null;
    }
  }

  function schreiben(werte) {
    try {
      localStorage.setItem(SPEICHER, JSON.stringify(werte));
    } catch (e) {}
  }

  function gueltig(werte) {
    return werte && werte.anzahl > 0 && werte.note >= 1 && werte.note <= 5;
  }

  function format(zahl, stellen) {
    return zahl.toLocaleString('de-DE', {
      minimumFractionDigits: stellen,
      maximumFractionDigits: stellen
    });
  }

  function zahlTauschen(el, wert) {
    var text = el.textContent;
    var neu = ZAHL.test(text) ? text.replace(ZAHL, wert) : wert;
    if (neu !== text) el.textContent = neu;
  }

  function anwenden(werte) {
    if (!gueltig(werte)) return;
    var anzahl = format(werte.anzahl, 0);
    var note = format(werte.note, 2);
    document.querySelectorAll('[data-lp-ts="count"]').forEach(function (el) {
      zahlTauschen(el, anzahl);
    });
    document.querySelectorAll('[data-lp-ts="rating"]').forEach(function (el) {
      zahlTauschen(el, note);
    });
  }

  function laden() {
    return fetch(FEED)
      .then(function (res) {
        if (!res.ok) throw new Error('Trusted Shops ' + res.status);
        return res.json();
      })
      .then(function (feed) {
        var grades = feed && feed.grades;
        var werte = {
          anzahl: grades && grades.overall && grades.overall.count,
          note: grades && grades['365days'] && grades['365days'].rating,
          zeit: Date.now()
        };
        if (!gueltig(werte)) throw new Error('Trusted Shops: Feed ohne Werte');
        schreiben(werte);
        return werte;
      });
  }

  function start() {
    if (!document.querySelector('[data-lp-ts]')) return;
    var gespeichert = lesen();
    // Wiederkehrende Besucher sehen sofort die letzte bekannte Zahl.
    if (gueltig(gespeichert)) anwenden(gespeichert);
    if (gueltig(gespeichert) && Date.now() - gespeichert.zeit < MAX_ALTER) return;
    laden().then(anwenden).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
